function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M5.73342 15.5L4.46675 13.3667L2.06675 12.8333L2.30008 10.3667L0.666748 8.5L2.30008 6.63333L2.06675 4.16667L4.46675 3.63333L5.73342 1.5L8.00008 2.46667L10.2667 1.5L11.5334 3.63333L13.9334 4.16667L13.7001 6.63333L15.3334 8.5L13.7001 10.3667L13.9334 12.8333L11.5334 13.3667L10.2667 15.5L8.00008 14.5333L5.73342 15.5ZM7.30008 10.8667L11.0667 7.1L10.1334 6.13333L7.30008 8.96667L5.86675 7.56667L4.93342 8.5L7.30008 10.8667Z",
  fill: "#E0E0E0"
});
const SvgNotVerified = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotVerified, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/not-verified.f0b6127a.svg";
export { ForwardRef as ReactComponent };